(function () {

    'use strict';

    /**
     * Initiates the expandable navigation.
     */
    const ExpandableNavigation = function (element) {

        this.element = element;
        this.trigger = element.getElementsByClassName('js-expand-nav--trigger')[0];
        this.navigation = document.body.getElementsByClassName('js-expand-nav--navigation')[0];
        this.breakpoint = matchMedia('(min-width: 64rem)');

        this.evaluateState = this.evaluateState.bind(this);
        this.expandNavigation = this.expandNavigation.bind(this);
        this.collapseNavigation = this.collapseNavigation.bind(this);

        this.initiateListener();
    }

    /**
     * Initiates the event listener.
     */
    ExpandableNavigation.prototype.initiateListener = function () {

        this.trigger.addEventListener('pointerdown', this.evaluateState);
        this.trigger.addEventListener('keydown', this.evaluateState);
    }

    /**
     * Evaluates the open state.
     */
    ExpandableNavigation.prototype.evaluateState = function (event) {

        event.stopPropagation();

        if (this.trigger.firstElementChild.getAttribute('aria-expanded') === 'false') {
            this.expandNavigation();

        } else {
            this.collapseNavigation(event);
        }
    }

    /**
     * Expands the navigation
     */
    ExpandableNavigation.prototype.expandNavigation = function () {

        // Expand the mobile menu
        this.trigger.firstElementChild.setAttribute('aria-expanded', 'true');

        window.addEventListener('pointerdown', this.collapseNavigation);
        window.addEventListener('keyup', this.collapseNavigation);
        this.breakpoint.addEventListener('change', this.collapseNavigation);
    }

    /**
     * Collapses the navigation
     */
    ExpandableNavigation.prototype.collapseNavigation = function (event) {

        let collapse = false;

        // Collapse when the window resizes
        if (event.type === 'change' && event.matches) {
            collapse = true;
        }

        if (event.type === 'keyup' && event.key === 'Escape') {
            collapse = true;
        }

        if (event.type === 'pointerdown' && event.target === this.trigger.firstElementChild) {
            collapse = true;
        }

        // Collapse when the navigation loses focus
        if(event.type === 'pointerdown' && !event.target.closest('.js-expand-nav')) {
            collapse = true;
        }

        // Dismiss if the navigation loses focus
        if (event.type === 'keyup' && !event.target.closest('.js-expand-nav')) {
            collapse = true;
        }

        if (collapse) {

            this.trigger.firstElementChild.setAttribute('aria-expanded', 'false');

            window.removeEventListener('keyup', this.collapseNavigation);
            window.removeEventListener('pointerdown', this.collapseNavigation);
            this.breakpoint.removeEventListener('change', this.collapseNavigation);
        }
    }

    const navigations = document.getElementsByClassName('js-expand-nav');

    for (const navigation of navigations) {
        new ExpandableNavigation(navigation);
    }
}());